<template>
    <div class="m-userinfo">

        <p class="info-txt">
            <span>欢迎，</span>            
            <span class="player-name">{{ ($store.state.userinfo.nickName || uid_handler($store.state.userinfo.uid) )|e }}</span>
            <span v-if="!$store.state.userinfo.uid" class="login u-btn" @click="call_login">请【登录】</span> 
            <span class="area-name" v-if="$store.state.login && $store.state.userinfo.zid">{{ queryArea($store.state.userinfo.zid) }}</span>
            <span v-if="$store.state.login && !$store.state.userinfo.zid" class="bind" @click="$bind_modal()">【绑定大区】</span>
            <span v-if="$store.state.login && $store.state.userinfo.zid" class="bind" @click="$bind_modal()">【切换大区】</span>
            <span v-if="$store.state.login && !KD.isApp()" class="logout u-btn" @click="call_logout">【退出】</span>          
        </p>
       
    </div>
</template>

<script>
import KD from '@/assets/js/kd.js';
import mslogin from '@/assets/js/msLogin.js';

export default {
    data (){
        return {
            KD : KD,
        }
    },
    props : {
        info : {
            default : () => {}
        },
        login_flag : {
            default : 0,
        },
    },
    filters : {
        e(str) {return str || '仙术师'}
    },    
    methods : {
        queryArea(num) {
            var area = '暂无大区信息';

            if (num == 1) {
                area = '火烧赤壁';
            } else if (num == 2) {
                area = '草船借箭';
            } else if (num == 6) {
                area = '荆州之战';
            } else if (num == 7) {
                area = '青梅煮酒';
            } else if (num == 8) {
                area = '官渡之战';
            } else if (num == 9) {
                area = '桃园结义';
            } else if (num == 11) {
                area = '九伐中原';
            } else if (num == 12) {
                area = '逐鹿中原';
            } else if (num == 13) {
                area = '三分天下';
            } else if (num == 16) {
                area = '怀旧服';
            }else if (num == 17) {
                area = '铜雀台';
            } else if (num == 18) {
                area = '凤仪亭';
            }else if (num == 19) {
                area = '火凤燎原';
            }else if (num == 20) {
                area = '卧龙出渊';
            }else if (num == 21) {
                area = '长生殿';
            }else if (num == 22) {
                area = '逍遥津';
            }else if (num == 23) {
                area = '单刀赴会';
            }else if (num == 100 || num == 101) {
                area = '测试大区';
            }

            return area;
        },

        call_login(){
            mslogin.open();
        },

        call_logout(){
            var _this = this;
            localStorage.clear();
            setTimeout(function () { 
                //TODO   
                document.location = _this.$global.domain;
            }, 100);             
        },

        call_buy (){

            if(!this.$store.state.userinfo.uid){
                return this.$mslogin.open();
            }

            if(!this.$store.state.userinfo.areaId){
                this.$toast('请绑定大区');
                return this.$bind_modal();
            }            

            this.$buy_Modal();
        },

        switch_area (){
            this.$close_book();
            this.$bind_modal();
        },

        uid_handler(uid){
            return uid ? uid.toString().slice(0,6) + '****' : '仙术师'    
        },
    },
}
</script>

<style scoped>
    .m-userinfo{
        /* display: flex; */
        position: relative;
        text-align: center;
        z-index: 10;
    }

    .u-btn.logout,
    .u-btn.login{
        /* color: #fff7c9; */
    }

    .login-state{
        /* height: 30px;
        line-height: 30px; */
    }

    /* @media not all and (min-width:900px){
        .m-userinfo{
            width: 750px;
            justify-content: center;
            font-size: 24px;
        }
    } */
</style>


// WEBPACK FOOTER //
// src/components/userinfo.vue